export const toNumber = (valor) => {
  const num = Number(valor)
  return Number.isFinite(num) ? num : 0
}

export const obtenerPrecioUnitarioMayorista = (item, cantidad) => {
  const cantidadEfectiva = toNumber(cantidad ?? item.cantidad)

  const tiersValidos = Array.isArray(item.preciosMayoristas)
    ? item.preciosMayoristas
        .map((p) => ({
          cantidad: toNumber(p.cantidad),
          precioUnitario: toNumber(p.precioUnitario ?? p.precio)
        }))
        .filter((p) => p.cantidad > 0 && p.precioUnitario > 0)
        .sort((a, b) => b.cantidad - a.cantidad)
    : []

  if (tiersValidos.length > 0) {
    const tier = tiersValidos.find((p) => cantidadEfectiva >= p.cantidad)
    if (tier) return tier.precioUnitario
  }

  return toNumber(item.precioUnitario) || toNumber(item.precioUnitarioSinDescuento) || 0
}

export const calcularTotalItemSinIva = (item) => {
  const precioUnitario = obtenerPrecioUnitarioMayorista(item)
  const porcDcto = toNumber(item.porcDcto)
  const factorDescuento = porcDcto > 0 && porcDcto < 100 ? 1 - porcDcto / 100 : 1
  const cantidad = toNumber(item.cantidad) || 1
  return precioUnitario * factorDescuento * cantidad
}

export const calcularTotalItemConIva = (item) => {
  const alicuota = toNumber(item?.alicuota)
  return calcularTotalItemSinIva(item) * (1 + alicuota / 100)
}
